










































import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { Toast } from 'vant';
import NumberKeyboard from "./NumberKeyboard.vue";
@Component({
    components: {NumberKeyboard},
}) 
export default class counter extends Vue {
   
    public $refs!: {
       
    };

    value=null;

    @Prop({
        default:4,
    })
    maxLength:number;

    @Prop({
        default:null,
    })
    defaultVal:Number;
    @Prop({
        default:false,
    })
    isDisabled:Boolean;
    @Prop({
        default:false,
    })
    addDisabled:Boolean;
    @Prop({
        default:0,
    })
    minVal:Number;
    @Prop({
        default:true,
    })
    needNumberKeyboard:Boolean;

    @Watch('defaultVal')
    defaultValChange(v){        
        this.value = v;
    }


    async mounted() {
        this.value = this.defaultVal;
    }
    async created() {
    
    }

    minusFun(){
        if(this.isDisabled)return;
        if(this.value == this.minVal) return;
        if(this.value){
            this.value--;
            this.finishFun();
        }
    }
    addFun(){
        if(this.isDisabled)return;
        if(this.addDisabled)return;
        if(this.value==9999)return;
        this.value++;
        this.finishFun();
    }
    changeVlues(val){
        this.value = val.target.value
        this.finishFun();
    }

    finishNum(val){
        this.value = val;
        this.finishFun();
    }
    finishFun(){
        this.$emit('finishStep',this.value)
    }

   
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/components/pad/counter.vue